import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import AboutBanner from "../Images/About Banner1.png";
import "./About.css";

function About() {
  return (
    <div >
        <Image src={AboutBanner} className='Banner-Img'/>
      <Container fluid className="about-page py-5">
        <Row className="justify-content-center">
          <Col lg={10}>
            
            <Card className="border-0 shadow-lg p-4 p-md-5 rounded-4">
              
              {/* Heading */}
              <div className="text-center mb-4">
                <h1 className="fw-bold text-success">About Nutrinest</h1>
                <p className="text-muted">
                  Nourish • Balance • Thrive
                </p>
              </div>

              {/* Content */}
              <div className="about-content">
                
                <p className="justify-text">
                  At <strong>Nutrinest</strong>, we believe good health begins
                  with the right nourishment. Our mission is to help you achieve
                  your goals through personalized, practical, and sustainable
                  nutrition without extreme diets or unrealistic restrictions.
                </p>

                <p className="justify-text">
                  We create science-backed diet plans tailored to your body,
                  lifestyle, and needs whether it’s weight loss, PCOS/PCOD
                  management, fitness, or building healthier habits.
                </p>

                <p className="justify-text">
                  Our approach is client-focused. We don’t just give diet plans
                  but provide continuous support, counseling, and simple
                  strategies that fit into your daily routine, using natural,
                  nutrient-rich foods.
                </p>

                <p className="justify-text">
                  From minimalist and premium plans to fitness collaborations
                  and coaching programs, Nutrinest offers solutions for every
                  need while staying focused on long-term, sustainable results.
                </p>

                <blockquote className="border-start border-success border-4 ps-3 my-4 fst-italic">
                  "Nutrinest is a nutrition and healthy lifestyle startup by a
                  Food Technologist, aimed at making affordable and sustainable
                  health solutions accessible to all."
                </blockquote>

                <p className="justify-text">
                  Join us to <strong>Nourish • Balance • Thrive</strong>;
                  because it’s not just about dieting, it’s about building a
                  healthier lifestyle.
                </p>

                <div className="mt-4">
                  <h5 className="text-danger mb-1">With Love,</h5>
                  <h4 className="fw-bold">Nutrinest – By Daksha</h4>
                </div>

              </div>

            </Card>

          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;